import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { ProjectTooltip } from '../Tooltips/ProjectTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export class ProjectCard extends ContentCard {

  public render() {
    return (
      <div className={CardViewStyles.Card}>
        {/*Project card shape overlays card to create cuttoff on top right corner*/}
        <img src = {imgPath('project_card_shape.svg')} className={CardViewStyles.ProjectCardShape}/>
        <TooltipAnchor tooltipContent={this.renderTooltipContent}
                       width={DetailsTooltipStyles.Width}
                       title={Messages.projectDetails()}
                       disableAutoFocus={this.props.content.owner && this.props.content.owner.isHiddenInternalUser}
                       disableTooltip={this.props.disableTooltip}>
          <Thumbnail navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
                     defaultImageUrl={getAssignedThumbnailImgPath(this.props.content.id)}
                     thumbnailImageUrl={getThumbnailUrlFromDescription(this.props.content.description)}
                     hoveredOrSelected={this.props.hoveredOrSelected}
                     imageCoverBackground={true}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            { this.props.content.name }
          </span>
          <span>
            <FavoriteToggle canHaveKeyboardFocus={true}
                            isFavorite={this.props.content.favorite}
                            onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'project' })}
                            onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'project' })}/>
          </span>
          { this.renderActionsMenu() }
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <ProjectTooltip content={this.props.content}
                           urls={this.props.urls} />;
  }
}

export function getThumbnailUrlFromDescription(description: string): string {
  const results = TextileHelper.TRAILING_IMAGE.exec(description);
  if (results) {
    return results[1];
  }
  return undefined;
}

function getAssignedThumbnailImgPath(projectId: string): string {
  // there are three possible default thumbnails for projects
  const index = Number.parseInt(projectId, 10) % 3 + 1;
  const filename = `project-thumb-${index}.png`;
  return imgPath(filename);
}
